class responsiveHelper{
	constructor() {
		
	}
	reorderElements() {
        // console.log('hi');
        // $('#slideout-about').insertAfter("ul.nav a[href='#slideout-about']");
        // $('#slideout-about').wrap( "<div class='tab-content' id='mobile-tabs'></div>" );
        // $('#slideout-markets').insertAfter("ul.nav a[href='#slideout-markets']");
        // $('#slideout-markets').wrap( "<div class='tab-content' id='mobile-tabs'></div>" );
        // $('#slideout-services').insertAfter("ul.nav a[href='#slideout-services']");
        // $('#slideout-services').wrap( "<div class='tab-content' id='mobile-tabs'></div>" );
        // $('#slideout-services').insertAfter("ul.nav a[href='#slideout-services']");
        // $('#slideout-services').wrap( "<div class='tab-content' id='mobile-tabs'></div>" );
        // $('#slideout-thinking').insertAfter("ul.nav a[href='#slideout-thinking']");
        // $('#slideout-thinking').wrap( "<div class='tab-content' id='mobile-tabs'></div>" );
	}
}
window.app.add('responsive', new responsiveHelper());